<div class="copo-container">
	<ng-template #loadingOrError>
		<copo-loading-spinner *ngIf="isLoading"></copo-loading-spinner>
	</ng-template>
	<div class="copo-section copo-error-label" *ngIf="!isSoldToAvailable">
		<span translate>fastlane.soldto.shipto.error</span>
	</div>
	<ng-container *ngIf="!isLoading && isSoldToAvailable; else loadingOrError">
		<div class="copo-section">
			<div class="copo-section-header">
				<span translate>eorder.create.order.title</span>
			</div>
			<div class="copo-section-body copo-grid">
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-form-field class="copo-form-field">
							<mat-label translate>eorder.wizard.header.customer-order-number</mat-label>
							<input
								#coNbrField
								type="text"
								matInput
								spellcheck="false"
								autocomplete="off"
								maxlength="32"
								required
								[formControl]="form.getFormCustomerOrderNumber()"
							>
							<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix>
							</mat-icon>
							<mat-hint align="end">{{coNbrField.value.length || 0}}/32</mat-hint>
							<mat-error *ngIf="form.getFormCustomerOrderNumber().hasError('required')">
								<span translate>eorder.wizard.header.customer-order-number.error.mandatory</span>
							</mat-error>
							<mat-error *ngIf="form.getFormCustomerOrderNumber().hasError('pattern')">
								<span translate>eorder.wizard.header.customer-order-number.error.invalid</span>
							</mat-error>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column">
						<!-- Sold-To -->
						<mat-form-field class="copo-form-field">
							<mat-label translate>eorder.wizard.order.soldto.name</mat-label>
							<mat-select [formControl]="form.getFormSoldTo()" [compareWith]="compareWithFn">
								<mat-option
									*ngFor="let soldTo of soldToBocList|copoSortOptions:false:configForBoc"
									[value]="soldTo.businessId"
									[matTooltip]="soldTo.name +' / '+ soldTo.city"
								>
									{{soldTo.name}}&nbsp;/&nbsp;{{soldTo.city}}
								</mat-option>
							</mat-select>
							<mat-error *ngIf="form.getFormSoldTo().hasError('required')">
								<span translate>eorder.wizard.header.customer</span>
							</mat-error>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column"></div>
					<div class="copo-grid-row-column"></div>
				</div>
				<div class="copo-header-product-infos-label" *ngIf="isCustomerNotSelected" translate>eorder.product.family.infos.title</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column" *ngIf="!isCustomerNotSelected && currencyList && currencyList.length > 0">
						<mat-form-field class="copo-form-field">
							<mat-label translate>eorder.wizard.summary.header.currency.po</mat-label>
							<mat-select [formControl]="form.getFormCurrency()" >
								<mat-option *ngFor="let currency of currencyList|copoSortOptions:false:configForCurrency" [value]="currency.code">
									{{currency.code}} - {{currency.description}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column"></div>
					<div class="copo-grid-row-column"></div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column"></div>
				</div>
			</div>

		</div>
	</ng-container>
</div>
<copo-eorder-wizard-stepprodspec *ngIf="isSoldToAvailable"></copo-eorder-wizard-stepprodspec>
